'use client'

import { useEffect } from 'react'

import { AppErrorFallback } from '@/components/misc/app-error-fallback'
import { reportClientCrash } from '@/lib/ops/report-client-crash'

interface ErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    reportClientCrash(error, {
      digest: error.digest,
      source: 'app-error',
    })
  }, [error])

  return (
    <AppErrorFallback
      title="Something went wrong"
      description="An unexpected error occurred. You can try again, or go back and continue from another page."
      digest={error.digest}
      onRetry={reset}
    />
  )
}
